const STORAGE_KEY = 'sonny.onboarding.inviteToken';

export const INVITE_QUERY_PARAM = 'convite';

// Token opaco base64url do link único de convite (/link/<token> no host do
// evento). Convite feito só com nome (sem CPF) usa esse link: o titular se
// cadastra por ele e cada dependente, de posse do MESMO link, faz o próprio
// cadastro (posse do link = autorização do titular).
const INVITE_TOKEN_PATTERN = /^[A-Za-z0-9_-]{8,128}$/;

export function normalizeInviteToken(value: string | null | undefined): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const token = value.trim();
  return INVITE_TOKEN_PATTERN.test(token) ? token : null;
}

/** Query ?convite= (propagação do QR de /mobile) — o path /link/<token> é tratado na rota. */
export function resolveInviteTokenFromSearch(search: string): string | null {
  return normalizeInviteToken(new URLSearchParams(search).get(INVITE_QUERY_PARAM));
}

function canUseSessionStorage(): boolean {
  try {
    return typeof sessionStorage !== 'undefined';
  } catch {
    return false;
  }
}

export function setStoredInviteToken(token: string): void {
  if (token === '' || !canUseSessionStorage()) {
    return;
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Modo privado ou storage desabilitado — o token segue valendo só para este load.
  }
}

export function getStoredInviteToken(): string | null {
  if (!canUseSessionStorage()) {
    return null;
  }
  try {
    return normalizeInviteToken(sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
}

/** Esquece o link pessoal guardado (entrada pela URL do evento / "não sou eu"). */
export function clearStoredInviteToken(): void {
  if (!canUseSessionStorage()) {
    return;
  }
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function storeInviteTokenFromLocation(location: { search: string }): void {
  const token = resolveInviteTokenFromSearch(location.search);
  if (token !== null) {
    setStoredInviteToken(token);
  }
}
